<template>
  <div id="terminal">
    <Carousel
      :value="images"
      :unstyled="false"
      circular
      :autoplayInterval="9000"
      :showNavigators="false"
      :showIndicators="false"
    >
      <template #item="slide">
        <NuxtImg
          :src="`${runtimeConfig.public.cms}${slide.data.url}`"
          class="dbc-c-image--cover"
          style="width: 100vw; height: 100vh"
        />
      </template>
    </Carousel>
  </div>
</template>

<script setup lang="ts">
import Carousel from 'primevue/carousel'

const runtimeConfig = useRuntimeConfig()
const images = await useFetchTerminalImages()

const metaTitle = 'Terminal'
const metaDescription = 'Terminal'
useHead({
  title: metaTitle,
  meta: [
    { name: 'description', content: metaDescription },

    {
      property: 'og:title',
      content: metaTitle,
    },

    {
      property: 'og:type',
      content: 'website',
    },

    {
      property: 'og:description',
      content: metaDescription,
    },

    {
      property: 'og:site_name',
      content: runtimeConfig.client as string,
    },
  ],
})
</script>
